import { Profiler } from 'react';
import { onPerfRender } from './PerfMonitor';
import { useIsPerfDebugMode } from './perfDebugMode';

type Props = {
  id: string;
  children: React.ReactNode;
};

/**
 * ?debug=perf のパフォーマンス計測が有効なときだけ React <Profiler> で子要素を包むラッパー。
 * 有効でなければ children をそのまま返す。
 */
export function PerfProfiler({ id, children }: Props) {
  const isPerfDebugMode = useIsPerfDebugMode();

  if (!isPerfDebugMode) return <>{children}</>;
  return (
    <Profiler id={id} onRender={onPerfRender}>
      {children}
    </Profiler>
  );
}
